import { createApiClient, getAuthHeaders } from "@/lib/api-client";

import type {
  GuardrailEvent,
  GuardrailMetricsQuery,
  GuardrailMetricsResponse,
  GuardrailMetricsSummary,
} from "./guardrail-metrics-types";

const metricsApi = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL
    ? `${import.meta.env.VITE_API_URL}/assistant`
    : "http://localhost:3001/assistant",
  getAuthHeaders,
});

export async function fetchGuardrailMetrics(
  query: GuardrailMetricsQuery
): Promise<{ summary: GuardrailMetricsSummary; events: GuardrailEvent[] }> {
  const params = new URLSearchParams();
  params.set("startTime", query.startTime);
  params.set("endTime", query.endTime);

  if (query.environment) {
    params.set("environment", query.environment);
  }
  if (query.policy) {
    params.set("policy", query.policy);
  }
  if (query.limit !== undefined) {
    params.set("limit", String(query.limit));
  }

  const response = await metricsApi.get<GuardrailMetricsResponse>(
    `/guardrail-metrics?${params.toString()}`
  );
  return { summary: response.data.summary, events: response.data.events };
}
